import apiClient from '@/plugins/axios';

export default {
	getRoundHistories(params, opts = {}) {
	const langCode = localStorage.getItem('lang') || 'sv';
	params.langCode = langCode;
	params.pageNumber = params.currentPage;
	delete params['currentPage'];

	return apiClient.get('v1/RoundHistory', { params, ...opts });
},

getRoundHistory(roundHistoryId) {
	const langCode = localStorage.getItem('lang') || 'sv';
	return apiClient.get(`v1/RoundHistory/${roundHistoryId}`, {
		params: { langCode }
	});
},


	createRoundHistory(roundHistory) {
		return apiClient.post('v1/RoundHistory', roundHistory);
	},

	updateRoundHistory(roundHistory) {
		var roundHistoryId = roundHistory.id;

		return apiClient.put(`v1/RoundHistory/${roundHistoryId}`, roundHistory);
	},

	deleteRoundHistory(roundHistoryId) {
		return apiClient.delete(`v1/RoundHistory/${roundHistoryId}`);
	},

	getCompletedRoundHistories(params, opts = {}) {
		params.pageNumber = params.currentPage;
		delete params['currentPage'];

		return apiClient.get('v1/RoundHistory/GetCompletedRoundHistories', { params, ...opts });
	},

	getUnCompletedRoundHistories(params, opts = {}) {
		params.pageNumber = params.currentPage;
		delete params['currentPage'];

		return apiClient.get('v1/RoundHistory/GetUnCompletedRoundHistories', { params, ...opts });
	}
};
